import TransacaoNotaFiscal from "model/fiscal/TransacaoNotaFiscal";
import { camposCadastraisEditaveisItem, camposTributariosItem, EmitirNotaFiscalSaida,
    ItemEmissaoNotaFiscalSaida, ParametrosFiscaisItemNotaFiscalSaida } from "model/vendas/EmitirNotaFiscalSaida";

export default class NotaFiscalSaidaItemService {
    contextoFiscal(item: ItemEmissaoNotaFiscalSaida, nota: EmitirNotaFiscalSaida): string {
        return JSON.stringify([nota.unidadeOrganizacional?.id, this.transacao(item, nota)?.id,
            nota.destinatario?.id, nota.enderecoDestinatario?.id, nota.consumidorFinal, nota.dataEmissao,
            nota.finalidade, item.produto?.codigo, item.informarCalculoIcms51 !== false]);
    }

    transacao(item: ItemEmissaoNotaFiscalSaida, nota: EmitirNotaFiscalSaida): TransacaoNotaFiscal | null {
        return item.transacaoNotaFiscal ?? nota.transacaoNotaFiscal;
    }

    transacaoCompativel(transacao: TransacaoNotaFiscal, nota: EmitirNotaFiscalSaida): boolean {
        const destino = nota.enderecoDestinatario?.uf && nota.unidadeOrganizacional?.uf
            ? nota.enderecoDestinatario.uf === nota.unidadeOrganizacional.uf ? "INTERNA" : "INTERESTADUAL"
            : nota.destinoOperacao;
        return transacao.ativa !== false && (!transacao.tipoOperacao || transacao.tipoOperacao === "SAIDA")
            && (!transacao.finalidadeNfe || transacao.finalidadeNfe === nota.finalidade)
            && (!transacao.destinoOperacao || !destino || transacao.destinoOperacao === destino);
    }

    valoresInformados(item: ItemEmissaoNotaFiscalSaida): Partial<ItemEmissaoNotaFiscalSaida> {
        // Notas anteriores ao registro da origem dos campos preservam os valores existentes.
        const campos = item.camposInformados ?? camposCadastraisEditaveisItem;
        return Object.fromEntries(camposCadastraisEditaveisItem
            .filter(campo => campos.includes(campo) && item[campo] != null && item[campo] !== "")
            .map(campo => [campo, item[campo]]));
    }

    entradaConsulta(item: ItemEmissaoNotaFiscalSaida, informados = this.valoresInformados(item)): ItemEmissaoNotaFiscalSaida {
        return { ...item, ...Object.fromEntries(camposCadastraisEditaveisItem.map(campo => [campo, null])), ...informados };
    }

    aplicarParametros(item: ItemEmissaoNotaFiscalSaida, fiscal: ParametrosFiscaisItemNotaFiscalSaida,
        informados = this.valoresInformados(item)): ItemEmissaoNotaFiscalSaida {
        return { ...item, ncm: fiscal.ncm, cest: fiscal.cest, cfop: fiscal.cfop,
            ...Object.fromEntries(camposTributariosItem.map(campo => [campo, fiscal[campo] ?? null])), ...informados };
    }

    limparPadroes(item: ItemEmissaoNotaFiscalSaida, informados = this.valoresInformados(item)): ItemEmissaoNotaFiscalSaida {
        return { ...item, ...Object.fromEntries(camposTributariosItem.map(campo => [campo, null])),
            cfop: "", ...informados };
    }
}
